import React from "react";
import { Link } from "react-router-dom";

export default function OnlineSpecial() {
  return (
    <section className="sd-special py-16" data-testid="online-special">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        <div className="flex items-center justify-center" data-testid="online-special-badge">
          <img
            src="/images/burger-badge.png"
            alt="Online Special 10% Off"
            className="max-w-sm w-full"
          />
        </div>
        <div className="sd-special-inner">
          <h2>1st-time Online Ordering:</h2>
          <p className="text-white/95 text-lg leading-relaxed mb-4">
            With the launch of our website and our Online Ordering facility, we
            offer a special <strong>10% discount on your first order</strong>{" "}
            through our online system. Just hit the Order NOW button and finish
            your first delivery order — our system will automatically reduce
            your costs by 10%.
          </p>
          <p className="text-white text-xl font-display mb-6">
            So, what are you waiting for?
          </p>
          <Link
            to="/order"
            className="sd-btn-yellow"
            data-testid="online-special-cta"
          >
            Order Now
          </Link>
        </div>
      </div>
    </section>
  );
}
